/**
 * PopiPlay RGS Provider Configuration
 * Provider-specific win thresholds, types, and settings
 */

export const PROVIDER_CONFIG = {
  // Provider identification
  PROVIDER_NAME: "PopiPlay",

  // Win thresholds (multiplier of bet size)
  WIN_THRESHOLDS: {
    BIG_WIN_THRESHOLD: 20, // 20x - 39x
    MEGA_WIN_THRESHOLD: 40, // 40x - 59x
    SUPER_MEGA_WIN_THRESHOLD: 60, // 60x+
  },

  // Win type constants
  WIN_TYPES: {
    BIG_WIN: "big_win",
    MEGA_WIN: "mega_win",
    SUPER_MEGA_WIN: "super_mega_win",
  },

  // Which wins trigger animated celebrations (full-screen win animation)
  ANIMATED_WIN_TYPES: ["big_win", "mega_win", "super_mega_win"],

  // Error code mappings - PopiPlay uses numeric codes (universal reference)
  // These are direct mappings since PopiPlay is the reference implementation
  ERROR_CODES: {
    301: 301, // not_enough_money
    205: 205, // free_rounds_available
    206: 206, // free_rounds_ended
    401: 401, // invalid_session
    400: 400, // invalid_bet
    500: 500, // server_error
    503: 503, // maintenance
    // Add more PopiPlay error codes as needed
  },
};
